import { Loader2 } from "lucide-react";

import { toolStatusLabel } from "./toolLabels";

/**
 * D-06's tool-status line: a 12px spinner and one hand-written Arabic label. NO LLM CALL -- a status
 * line that costs a model round trip arrives after the thing it was describing.
 *
 * NO BUBBLE, on the bot's side. That is what makes it read as chrome rather than as ناصح saying
 * something: the separation from body text is carried by the CONTAINER (no background, no padding,
 * sitting outside any bubble), not by tinting the text down to a grey that fails contrast.
 *
 * ONE LINE AT A TIME, REPLACED AND NEVER APPENDED (D-07). The context holds a single `toolName` and a
 * second tool overwrites the first rather than stacking under it, so a run that touches four tools
 * leaves no four-line log of its own thinking in the transcript.
 *
 * TRANSIENT, AND NEVER PERSISTED AS A MESSAGE. The context clears `toolName` the moment the first
 * delta lands, so the answer REPLACES the status rather than appearing beneath it. Admins who need
 * the real tool calls have the Phase 33 traces; a visitor does not need a receipt.
 *
 * An unmapped tool renders the fallback label, so a tool added on the server degrades to a truthful
 * generic instead of showing a machine identifier or an empty row.
 */
export default function ChatStatusLine({ toolName }: { toolName: string | null }) {
  if (toolName === null) return null;

  return (
    <div className="flex items-center gap-1">
      <Loader2
        size={12}
        strokeWidth={2}
        aria-hidden="true"
        className="shrink-0 animate-spin text-[var(--ys-ink-2)]"
      />
      <span style={{ fontSize: 13, fontWeight: 400, lineHeight: 1.5, color: "var(--ys-ink-2)" }}>
        {toolStatusLabel(toolName)}
      </span>
    </div>
  );
}
